import { render, staticRenderFns } from "./atendimento-solicitacoes.vue?vue&type=template&id=07484465&"
import script from "./atendimento-solicitacoes.vue?vue&type=script&lang=js&"
export * from "./atendimento-solicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./atendimento-solicitacoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports